import { onDomReady } from '../utils/dom';

/**
 * @type {HTMLElement|null}
 */
let root = null;

/**
 * @type {HTMLElement|null}
 */
let inside = null;

/**
 * @type {HTMLElement|null}
 */
let container = null;

/**
 * @type {HTMLElement|null}
 */
let logo = null;

let stickyThreshold = 0;

// Get the height of the header by the top offset of the next element
export const getHeight = () => container.offsetTop.toFixed(0);

// Sticky erst ab der Unterkante der überlappenden Logo-Box; der Wert wird gecacht,
// weil die Box im Sticky-Zustand display:none hat und dann nicht messbar ist.
const updateStickyThreshold = () => {
    if (logo && logo.offsetHeight > 0) {
        stickyThreshold = logo.offsetTop + logo.offsetHeight;
    } else if (!stickyThreshold) {
        stickyThreshold = Number.parseInt(getHeight());
    }
};

// Get the current height of header_inside.
export const getInnerHeight = () => inside.getBoundingClientRect().height.toFixed(1);

// Get the position from which the header should be fixed.
export const getFixedPosition = () => window.innerHeight / 2;

function showFixedHeader() {
    updateStickyThreshold();

    const scrolledTop = document.documentElement.scrollTop;
    const classList = root.classList;

    if (scrolledTop > stickyThreshold) {
        classList.add('sticky');

        if (classList.contains('menu-open') || classList.contains('level-open')) {
            classList.add('keep');
        }

        if (scrolledTop > getFixedPosition()) {
            classList.add('show');
        } else {
            classList.replace('show', 'hide');
        }
    } else {
        classList.remove('sticky', 'hide', 'keep', 'show');
    }
}

onDomReady(() => {
    root = document.querySelector('#header');
    inside = root.querySelector('.header_inside');
    container = document.querySelector('#header + div');
    logo = root.querySelector('#logo');

    showFixedHeader();
});

window.addEventListener('scroll', () => {
    showFixedHeader();
});

window.addEventListener('resize', () => {
    showFixedHeader();
});
